/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		minHeight: 40,
	},

	cell: {
		fontSize: 8,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
	},

	id: { borderLeftWidth: 1, borderLeftColor: borderColor },

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	}
});

const InvoiceTableRow = (props) => {
	const { data, columnStyles } = props;
	const rows = data?.map((item, index) => (
		<View key={index} wrap={false}>
      
			<View style={styles.row}>
				<Text style={[styles.cell, styles.id, columnStyles.id]}>{item.id ?? 'No data'}</Text>
				<Text style={[styles.cell, columnStyles.name]}>{item.name}</Text>
				<Text style={[styles.cell, columnStyles.region]}>{item.regionInfo}</Text>
				<Text style={[styles.cell, columnStyles.pids]}>{item.pids_name}</Text>
				<Text style={[styles.cell, columnStyles.channel]}>{item.channel_name}</Text>
				<Text style={[styles.cell, columnStyles.type]}>{item.isparent}</Text>
				<Text style={[styles.cell, columnStyles.date]}>{item.date}</Text>
				<Text style={[styles.cell, columnStyles.chainage]}>{item.pipelineChainage}</Text>
				<Text style={[styles.cell, columnStyles.gps]}>{item.showGPS}</Text>
				<Text style={[styles.cell, columnStyles.user]}>{item.userName || '-'}</Text>
				<Text style={[styles.cell, columnStyles.status]}>{item.status}</Text>
			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;